import { useAppContext } from "@components/context";
import { handleFnsIntl } from "@locale/utils";

export const useFnsLanguage = () => {
  const { language } = useAppContext();
  const dateLocale = handleFnsIntl(language);
  return dateLocale;
};
